import { store } from "common/store";
import { ActivatedPriceListAsyncActions } from "common/reducers/activatedPriceList.async.actions";
import { estimate as estimateSelector } from "common/selectors/estimate.selectors";
import { activatedPriceListHydrated } from "common/selectors/activatedPriceList.selectors";
import { watchCurrentOrgId } from "src/router/loaders/helper";

/**
 * Hydrates the activated price list snapshot for an estimate, if not already hydrated. The Product
 * Selector reads this snapshot (not the live products endpoint) because a saved estimate can
 * reference an older snapshot than the org's current APL.
 *
 * Loads eagerly on every estimate load/create, not gated on `show_product_selector`, so the
 * dropdown is populated on any estimate; the ProductSelector's mount-time fetch is a fallback only.
 * Waits for `currentOrgId` first (parallel loaders set it asynchronously, and the thunk no-ops
 * without it).
 *
 * @param estimateId — the id (positive or negative) of the estimate whose snapshot to load
 */
export const loadEstimateActivatedPriceList = async (estimateId: number): Promise<void> => {
  await watchCurrentOrgId();
  const state = store.getState();
  const est = estimateSelector(state, { estimateId });
  if (!est) return;
  const aplId = est.activated_price_list_id as number | undefined | null;
  if (!aplId) return;
  if (activatedPriceListHydrated(state, aplId)) return;
  await store.dispatch(ActivatedPriceListAsyncActions.getActivatedPriceList(aplId));
};
